import { __decorate } from "tslib";
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClickOutsideDirective } from './click-outside.directive';
let ClickOutsideModule = class ClickOutsideModule {
};
ClickOutsideModule = __decorate([
    NgModule({
        imports: [CommonModule],
        declarations: [ClickOutsideDirective],
        exports: [ClickOutsideDirective],
    })
], ClickOutsideModule);
export { ClickOutsideModule };
